import React, { useEffect, useRef, useState } from 'react';

/**
 * WunderBirkenstockEngagement: "Wunder_Engagement_Birkenstock" Meta kampanyasının
 * kreatif karesiyle birlikte tam metrik raporu.
 * Route: /r/wunder-birkenstock-engagement (Layout İÇİNDE — sidebar VAR)
 *
 * Wunder 2026 platformda gerçek marka, o yüzden `allowBrandIds` deseni.
 *
 * 🔑 Rapor bilerek sidebar'lı: panelin dışında duran bağımsız bir belge gibi
 * görünmemeli. Aynı sebeple gömülü HTML'in tasarımı da panelin diline göre
 * yazıldı (system-ui sans, #F6F8FF zemin, beyaz rounded-xl kart, #436AEB mavi) —
 * serif/mono kullanılmıyor. HupalupaLokasyonReport deseni: iframe içerik
 * alanının kalan yüksekliğine oturur, rapor kendi içinde kayar.
 *
 * İçerik statik — sayfa çalışırken API çağrısı YOK. Rakamlar 24 Ağu 2026'da Meta
 * Graph API v23.0'dan (act_306233716767502, kampanya 120246150885780662,
 * 20–24 Ağu aralığı) çekilip HTML'e gömüldü. Yenilemek için:
 *   node src/pages/wunder-birkenstock-engagement/build.js
 * (kaynak dump.json + imgs.json aynı klasörde).
 *
 * 🔑 "PDF olarak yazdır" düğmesi iframe'in KENDİ belgesinde window.print() çağırır
 * — dış sayfadan Ctrl+P iframe'i tek sayfaya kırpar. Düğmeyi dışarı taşıma.
 *
 * HTML modülü ~245KB: videodan çıkarılmış 7 kare data URI olarak gömülü
 * (public/ altındaki statik klasörler setupProxy 502 tuzağına düşüyor).
 * Ana bundle'da işi yok, dinamik import ile yükleniyor.
 */
export default function WunderBirkenstockEngagement() {
  const [html, setHtml] = useState(null);
  const [height, setHeight] = useState(720);
  const boxRef = useRef(null);

  useEffect(() => {
    let alive = true;
    import('./wunderBirkenstockEngagementHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px;color:#111827">Rapor yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  // iframe'i içerik alanının kalan yüksekliğine oturt. Rapor kendi içinde kayar,
  // sayfa gövdesi kaymaz — iki kaydırma çubuğu üst üste binmesin.
  useEffect(() => {
    const fit = () => {
      const top = boxRef.current?.getBoundingClientRect().top ?? 0;
      setHeight(Math.max(480, window.innerHeight - top - 12));
    };
    fit();
    window.addEventListener('resize', fit);
    return () => window.removeEventListener('resize', fit);
  }, [html]);

  return (
    <div ref={boxRef} className="px-1.5 pb-1.5">
      {html ? (
        <iframe
          title="Wunder × Birkenstock · Engagement Raporu"
          srcDoc={html}
          style={{
            width: '100%',
            height,
            border: '1px solid #E5E7EB',
            borderRadius: 12,
            display: 'block',
            background: '#F6F8FF',
          }}
        />
      ) : (
        <div style={{ height, borderRadius: 12, background: '#F6F8FF' }} aria-busy="true" />
      )}
    </div>
  );
}
